import React from "react";
import { connect } from "react-redux";
import { isBigger } from "store/actions/device";
import { WrapContent } from "./theme";

// `admin`: the sidebar is always present on desktop (extended or icons only), floating below
// "md". Without it (employee portal) the legacy drawer pushes the content only while open.
class MainContent extends React.Component {
    render() {
        const { device, mini, menuOpen, admin } = this.props;
        const desktop = isBigger(device, "md");
        let contentClass = "os-wrapcontent fullwidth";
        if (admin && desktop) contentClass = `os-wrapcontent with-menu${mini ? " mini" : ""}`;
        else if (!admin && desktop && menuOpen) contentClass = "os-wrapcontent with-legacy-menu";
        return (
           <WrapContent>
                <div className={contentClass}>
                    {this.props.children}
                </div>
           </WrapContent>
        );
    }
}


const mapStateToProps = state => {
    return {
        mini: Boolean(state.menu.mini),
        menuOpen: state.menu.isOpen,
        device: state.device.type
    };
};

export default connect(mapStateToProps)(MainContent);
